import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Box,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { jwtDecode } from "jwt-decode"; 
import { menus } from "../data/sidebarData";
import logo from "../assets/logo/autolux-logo.png";
import "../styles/global.css/navbar.css";

export default function Sidebar({ open }) {
  const navigate = useNavigate();
  const location = useLocation();

  let role = "seller"; 
  const token = localStorage.getItem("token");
  if (token) {
    try {
      const decoded = jwtDecode(token);
      role = String(decoded?.admin).toLowerCase() === "true" ? "admin" : "seller";
    } catch {}
  }
  

  const defaultMenu = menus[role][0].title;
  const defaultSub = menus[role][0].subItems[0].path;

  const [openMenu, setOpenMenu] = useState(defaultMenu);
  const [selectedSub, setSelectedSub] = useState(defaultSub);

  useEffect(() => {
    const currentPath = location.pathname.split("/").pop();
    if (currentPath) {
      const currentMenu = menus[role].find(menu =>
        menu.subItems.some(sub => sub.path === currentPath)
      );
      if (currentMenu) setOpenMenu(currentMenu.title);
      setSelectedSub(currentPath);
    }
  }, [location.pathname, role]);

  const handleMenu = (title) => {
    setOpenMenu(openMenu === title ? null : title);
  };

  const handleSubClick = (sub) => {
    setSelectedSub(sub.path);
    navigate(`/${role}/${sub.path}`);
  };

  return (
    <Drawer
      variant="persistent"
      open={open}
      className="sidebar"
      sx={{
        "& .MuiDrawer-paper": {
          width: 300,
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
          overflow: "hidden",
          transition: "all 0.3s ease",
        },
      }}
    >
      <Box
        className="sidebar-box"
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
        }}
      >
        <List>
          <Box className="sidebar-logo">
            <img draggable={false} src={logo} alt="logo" className="sidebar-logo-img" />
          </Box>

          <div className="sidebar-section-title">Səhifələr</div>

          {menus[role].map((menu) => (
            <Box key={menu.title}>
              <ListItemButton
                className={`sidebar-menu-btn ${openMenu === menu.title ? "active" : ""}`}
                onClick={() => handleMenu(menu.title)}
                sx={{ position: "relative" }}
              >
                {openMenu === menu.title && (
                  <Box
                    sx={{
                      position: "absolute",
                      left: 0,
                      top: 0,
                      height: "100%",
                      width: "3px",
                      backgroundColor: "#3B7DDD",
                    }}
                  />
                )}

                <ListItemIcon className="sidebar-icon">
                  <menu.icon style={{ width: 24, height: 24 }} />
                </ListItemIcon>

                <ListItemText
                  primary={menu.title}
                  primaryTypographyProps={{ fontWeight: 600 }}
                />

                {openMenu === menu.title ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>

              <Collapse in={openMenu === menu.title} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {menu.subItems.map((sub) => (
                    <ListItemButton
                      key={sub.title}
                      className="sidebar-submenu-btn"
                      onClick={() => handleSubClick(sub)}
                      sx={{ pl: 3, position: "relative" }}
                    >
                      

                      <ListItemIcon sx={{ minWidth: 24, mr: 1, display: "flex", justifyContent: "center" }}>
                        {sub.icon && (
                          <sub.icon 
                            style={{ 
                              width: 18, 
                              height: 18, 
                              color: selectedSub === sub.path ? "#3B7DDD" : "rgba(255, 255, 255, 0.7)" 
                            }} 
                          />
                        )}
                      </ListItemIcon>

                      <ListItemText
                        primary={sub.title}
                        primaryTypographyProps={{
                          fontSize: 14,
                          color: selectedSub === sub.path ? "#3B7DDD" : "#fff",
                        }}
                      />
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            </Box>
          ))}
        </List>
      </Box>
    </Drawer>
  );
}
